<template>
    <div class="shop-list">
        <div v-for="(item,index) in data" :key="index" class="shop-list-item list-item-inline">
            <div class="item shadow-bg" v-on:click="onInfoClick(item)">
                <div
                    class="img bg-100 bh"
                    v-lazy:background-image="item.smallPic"
                    v-on:click.stop="onInfoClick(item)"
                >
                    <div v-if="!item.stock" class="tag fz_30 tc"></div>
                </div>
                <div class="content">
                    <div class="fz_30 overflow">{{item.name}}</div>
                     <div class="fz_24 c_999 overflow breakword title">{{item.subName}}</div>
                    <div class="bh bc ico-container">
                        <i class="bg-contain ico-maintenance"></i>
                        <span class="b1 overflow c_red fz_34">{{item.price}}</span>
                        <span class="c_666 fz_24">{{getSale(item.allSale)}}人已兑换</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import util from "@/utils/index";
export default {
    name: "CarGoodsItem",
    props: {
        data: Array,
        // 标识当前是否商品列表页面
        isGoodHome: {
            type: Boolean,
            default: false
        },
        // 跳转时是否清除历史记录
        isReplace: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getSale(v) {
            return util.plusNumber(v);
        },
        onInfoClick(item) {
            const me = this,
                params = {
                    name: "CarGoodsInfo",
                    params: {
                        id: item.id,
                        isGoodHome: me.isGoodHome
                    }
                };
            // 标识当前是否商品列表页面
            // 用于商品详情跳转到商品列表时判断跳转逻辑
            if (!me.isReplace) {
                me.$router.push(params);
            } else {
                me.$router.replace(params);
            }
        }
    }
};
</script>
